import { render, staticRenderFns } from "./items.vue?vue&type=template&id=f3adc408"
import script from "./items.vue?vue&type=script&lang=js"
export * from "./items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports